import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  imports: [],
  selector: 'app-header-loader',
  templateUrl: './header-loader.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./header-loader.component.scss'],
})
export class HeaderLoaderComponent {
  @Input() isBodyText?: boolean;
}
